import React from 'react';

const LoadingSpinner = ({ size = 'md', text = 'Chargement...' }) => {
  const sizes = {
    sm: { width: '30px', height: '30px', borderWidth: '3px' },
    md: { width: '40px', height: '40px', borderWidth: '4px' },
    lg: { width: '60px', height: '60px', borderWidth: '5px' }
  };
  const sizeStyle = sizes[size] || sizes.md;

  return (
    <div className="spinner-center">
      <div style={{ textAlign: 'center' }}>
        <div className="spinner" style={sizeStyle}></div>
        <p className="loading-text">{text}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
